export default __webpack_public_path__ + "static/media/IconDesc_UraniumPellets.64.c4569410.png";